import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "accordionButton",
  key: "up"
}
const _hoisted_2 = { type: "button" }
const _hoisted_3 = {
  class: "accordionButton",
  key: "down"
}
const _hoisted_4 = { type: "button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_chevron_up = _resolveComponent("icon-chevron-up")!
  const _component_icon_chevron_down = _resolveComponent("icon-chevron-down")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["accordion", _ctx.openThis ? 'open' : ''])
    }, [
      _createElementVNode("div", {
        class: "accordionTitle",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openThis = !_ctx.openThis))
      }, [
        _renderSlot(_ctx.$slots, "title", {}, undefined, true),
        (_ctx.openThis)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("button", _hoisted_2, [
                _createVNode(_component_icon_chevron_up)
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.openThis)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("button", _hoisted_4, [
                _createVNode(_component_icon_chevron_down)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.openThis)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["accordionBody", {'indent': _ctx.indent}])
          }, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ], 2))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}